import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getAllTicketPriorities = () => {
  return useApi(http.get(`/settings/ticket-priorities`))
}
export const deleteTicketPriority = (id: string) => {
  return useApi(http.delete(`/settings/ticket-priorities/${id}`))
}
export const createTicketPriority = (data: any) => {
  return useApi(http.post(`/settings/ticket-priorities`, data))
}
export const updateTicketPriority = (id: number, data: any) => {
  return useApi(http.put(`/settings/ticket-priorities/${id}`, data))
}
export const updateTicketPriorityPositions = (positions: { id: string; position: number }[]) => {
  return useApi(http.patch(`/settings/ticket-priorities/positions`, { positions }))
}
